import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin, Mail } from "lucide-react";

export function Footer({ onRegister }) {
  return (
    <footer data-testid="footer" className="relative bg-ink border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4">
              <img src="/logo-ajdr.png" alt="AJDR Factory" className="w-16 h-16 rounded-full" data-testid="footer-logo" />
              <div className="font-display font-black text-2xl">AJDR<span className="text-mustard">.</span> Factory</div>
            </div>
            <p className="mt-4 text-cream/60 max-w-sm leading-relaxed text-sm">
              Association des Jeunes Danseurs de Rue. Centre artistique dédié à la culture Hip-Hop
              depuis 1996. Un lieu de vie, de création et de refuge à Albi.
            </p>
            <div className="mt-5 flex gap-3">
              {[Instagram, Facebook, Youtube].map((Icon, i) => (
                <a key={i} href="#" data-testid={`footer-social-${i}`} className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-cream/70 hover:text-mustard hover:border-mustard transition" aria-label="réseau social">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-sub font-semibold text-cream mb-4">Naviguer</h4>
            <ul className="space-y-2 text-sm text-cream/60">
              {[["histoire","Histoire"],["disciplines","Disciplines"],["profs","Profs"],["planning","Planning"],["events","Événements"]].map(([id,l]) => (
                <li key={id}><button onClick={() => document.getElementById(id)?.scrollIntoView({behavior:"smooth"})} className="hover:text-mustard transition">{l}</button></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-sub font-semibold text-cream mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-cream/60">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-mustard" /> Albi, France</li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-mustard" /> contact@ajdrfactory.fr</li>
            </ul>
            <button onClick={onRegister} data-testid="footer-register-btn" className="btn-mustard rounded-full px-5 py-2.5 text-sm mt-5">S'inscrire</button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/40 font-mono2">
          <span>© {new Date().getFullYear()} AJDR Factory — Tous droits réservés.</span>
          <div className="flex items-center gap-4">
            <span>Données gérées dans le respect du RGPD</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-mustard transition">Espace Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
